module.exports = __webpack_public_path__ + "static/media/seventy_percent.f63a4432.png";